/**
 * Builds the newquotetool.irrigreen.com URL for address / design-tool CTAs.
 * Uses window.__IRG_B2B_QUOTE_TOOL (from b2b-quote-tool-redirect-config) when the customer is B2B.
 */
(function (win) {
  // Appends current-page tracking params (utm_*, gclid, ...) when the global
  // decorator (assets/quote-tool-tracking.js) is present; no-op otherwise.
  function withTracking(url) {
    return typeof win.irgAppendQuoteToolTracking === 'function' ? win.irgAppendQuoteToolTracking(url) : url;
  }

  function buildQuoteToolUrl(inputVal) {
    var b2b = win.__IRG_B2B_QUOTE_TOOL;
    if (b2b && b2b.query) {
      var q = new URLSearchParams();
      Object.keys(b2b.query).forEach(function (k) {
        var v = b2b.query[k];
        if (v !== null && v !== undefined && String(v) !== '') q.set(k, String(v));
      });
      if (inputVal) q.set('address', inputVal);
      var base = (b2b.baseUrl || 'https://newquotetool.irrigreen.com/').replace(/\/?$/, '');
      return withTracking(base + '?' + q.toString());
    }
    return withTracking(
      inputVal
        ? 'https://newquotetool.irrigreen.com?address=' + encodeURIComponent(inputVal)
        : 'https://newquotetool.irrigreen.com'
    );
  }

  win.buildQuoteToolUrl = buildQuoteToolUrl;
})(window);
